import { Modal } from 'carbon-components-react';
import CustomButton from '../../components/custom-button/custom-btn.component';
import './dashboard.styles.scss';
import EpobsDailyFeeTermsAndConditions from './EpobsDailyFeeTermsAndConditions';

export default function DailyFeeTermsModal({ isOpen, closeModal }) {
  return (
    <Modal
      id="terms-conditions-modal"
      className="terms-conditions-modal"
      hasScrollingContent
      passiveModal={true}
      open={isOpen}
      modalHeading="Daily Fee Terms and Conditions"
      primaryButtonDisabled={false}
    >
      <div className="terms-content">
        <EpobsDailyFeeTermsAndConditions />
      </div>

      <div className="mt-40" style={{ justifySelf: 'end' }}>
        <CustomButton
          classes="outline secondary font-bold"
          style={{ flex: '1' }}
          onClick={closeModal}
        >
          CLOSE
        </CustomButton>
      </div>
    </Modal>
  );
}
